import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { UserNotificationActivityKind } from '../../../services';
import { PreferenceRow, PreferencesSection } from '../PreferencesSection';
import { SettingsSection } from '../SettingsSection';
import { useNotificationPreference } from '../useNotificationPreference';

interface ActivitySectionProps {
  isPushLocked?: boolean;
}

export const ActivitySection: FunctionComponent<ActivitySectionProps> = ({ isPushLocked }) => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'pushNotifications' });

  const { preference, setPushEnabled, setEmailEnabled } = useNotificationPreference();

  if (!preference) {
    return null;
  }

  return (
    <SettingsSection title={ctxT('activity-title')} hint={ctxT('activity-hint')}>
      <PreferencesSection>
        {Object.values(UserNotificationActivityKind).map((kind) => {
          const value = preference[kind];

          return (
            <PreferenceRow
              key={kind}
              label={ctxT(`activity-${kind}`)}
              isPushEnabled={value.push}
              onPushChange={(isEnabled) => setPushEnabled({ kind, isEnabled })}
              onEmailChange={(isEnabled) => setEmailEnabled({ kind, isEnabled })}
              isPushLocked={isPushLocked}
              {...('email' in value && { isEmailEnabled: value.email })}
            />
          );
        })}
      </PreferencesSection>
    </SettingsSection>
  );
};
